import * as React from "react"
import styled from "styled-components"
import PropTypes from "prop-types"
import parse from "html-react-parser"
import DiscoveryForm from "./form"

const Split50 = styled.div`
    display: flex;
    align-items: center;

    form {
        margin-bottom: 0;
    }

    @media (max-width: 1000px) {
        flex-direction: column;
    }
`

const Content = styled.div`
    flex: 1 1 60%;
    min-width: 60%;
    max-width: 60%;
    padding: 40px;
    font-size: clamp(1.1rem, 0.8857rem + 0.9524vw, 1.6rem);

    h2 {
        font-size: 1.2em;
    }

    ol li {
        font-size: 1em;
    }

    .has-medium-font-size {
        font-size: 1.1em !important;
    }

    @media (max-width: 1000px) {
        flex: 1 1 100%;
        min-width: 100%;
        max-width: 100%;
        padding-left: 0;
        padding-right: 0;
    }
`

const DiscoveryContent = ({ content, hook }) => {
    return(
        <Split50>
            <Content>
                <h1>Request Consultation</h1>
                { parse( content ) }
            </Content>
            <DiscoveryForm hook={hook} />
        </Split50>
    )
}

DiscoveryContent.propTypes = {
    content: PropTypes.string,
    hook: PropTypes.string
}

DiscoveryContent.defaultProps = {
    content: ``,
    hook: 'https://hooks.zapier.com/hooks/catch/4189994/b0t6bgg/',
}

export default DiscoveryContent;
